<app-dc-header class="header">
  <app-dc-alert></app-dc-alert>
  <span class="heading">Product Portfolio</span>
  <div class="actions">
    <app-dc-csv-download-button
      [data]="csvData$"
      fileName="Product Portfolio"
      class="download-button"
      *restrictTo="'DOWNLOAD_PRODUCT_PORTFOLIO_CSV_FILE'"
    ></app-dc-csv-download-button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      routerLink="create-product/new"
      *restrictTo="'NEW_PRODUCT'"
    >
      New Product
    </button>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm"
      (click)="openImportProductModal()"
      *restrictTo="'IMPORT_PRODUCT'"
    >
      Import Product
    </button>
  </div>

  <form [formGroup]="tableFiltersForm" class="tableFilters">
    <div
      class="d-lg-flex"
      style="justify-content: space-between; padding-top: 10px"
    >
      <div class="d-lg-flex">
        <div class="mr-lg-2" style="min-width: 250px">
          <app-dc-select
            [items]="productTypesSelect"
            formControlName="productType"
            [placeholder]="'All Products'"
            [multiple]="false"
            [searchable]="false"
            [closeOnSelect]="true"
            [readonly]="false"
            [darkMode]="true"
            [clearInputX]="true"
          ></app-dc-select>
        </div>

        <div class="mr-lg-2" style="min-width: 135px">
          <app-dc-input
            [placeholder]="'All Tenors'"
            formControlName="tenor"
            [pattern]="'[0-9]{1,3}[dmywDMYW]{1}'"
            [helpText]="
              'Format is NNNT where NNN is a number and T is a type:<br><br>D = numbers 1 to 365 only<br>M = numbers 1 to 12 only<br>Y = numbers 1 to 99 only<br>W = numbers 1 to 52 only.'
            "
            customErrorMessage="Please use correct formatting e.g. 1D, 3W, 5M, or 2Y"
            [darkMode]="true"
          ></app-dc-input>
        </div>

        <div class="mr-lg-2" style="min-width: 135px">
          <app-dc-select
            [items]="currencySelect$ | async"
            [checkbox]="true"
            formControlName="currency"
            [placeholder]="'All Currencies'"
            [multiple]="false"
            [searchable]="false"
            [closeOnSelect]="true"
            [readonly]="false"
            [darkMode]="true"
            [clearInputX]="true"
          ></app-dc-select>
        </div>

        <div class="mr-lg-2" style="min-width: 235px">
          <app-dc-date-input-range
            [id]="'datePickerComponent'"
            formControlName="dateRange"
            [placeholder]="'All Dates'"
            [showClear]="true"
            [darkMode]="true"
          ></app-dc-date-input-range>
        </div>
      </div>

      <div style="min-width: 300px; position: relative">
        <app-dc-search
          formControlName="searchTerm"
          placeholder="Search products"
          [darkMode]="true"
          (clearFilter)="clearSearch()"
        ></app-dc-search>
      </div>
    </div>
  </form>
</app-dc-header>

<article #productCaptureList class="content">
  <app-product-capture-list
    [rows]="rows"
    [loading]="loading"
    [pageData]="pageData"
    (deleteRow)="deleteRow($event)"
    (onPageChange)="pageChange($event)"
  ></app-product-capture-list>
</article>
